module.exports = __webpack_public_path__ + "static/media/cq_alert_red.9c9f80d1.svg";